import React from "react";
import { makeStyles } from "@material-ui/core/styles";
//   IconButton,
import { Toolbar, Typography, useTheme, IconButton } from "@material-ui/core";
import fontConfig from "../../constants/fonts";
import DesktopHidden from "../../components/Common/Hidden/DesktopHidden";
import MobileHidden from "../../components/Common/Hidden/MobileHidden";
import MenuIcon from "@material-ui/icons/Menu";
import { toggleDrawer } from "../../redux/action/utilActions";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getImageUrl } from "../../redux/types";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "white",

    [theme.breakpoints.down("md")]: {
      backgroundColor: "white",
    },
  },
  container: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  headline: {
    ...fontConfig.medium,
    fontSize: "1.2rem",
  },
  mainContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  gramTitleContainer: {
    paddingLeft: theme.spacing(1),
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  },
  distsubDistrictContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  },
  logo: {
    height: 80,

    marginBottom: theme.spacing(1),
    // marginTop: theme.spacing(1),
    padding: theme.spacing(1),
    objectFit: "contain",
    cursor: "pointer",
    [theme.breakpoints.down("md")]: {
      marginTop: theme.spacing(1),
      padding: 0,

      // paddingTop: theme.spacing(0),
      // marginTop: theme.spacing(0),
      height: 60,
      // marginBottom: theme.spacing(0),
    },
    // width: "20vh",
  },
  subdistrict: {
    [theme.breakpoints.down("md")]: {
      fontSize: "0.7rem",
    },
  },
  district: {
    marginLeft: theme.spacing(3),
    [theme.breakpoints.down("md")]: {
      fontSize: "0.7rem",
    },
  },
  otherLogo: {
    height: 50,
  },
  menuIcon: {
    fontSize: "2rem",
  },
  otherlogoContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "flex-end",
  },
  panchContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    flex: 1,
  },
  panch: {
    width: "20vw",
    objectFit: "contain",
  },
}));

const Navbar = ({ data }) => {
  const classes = useStyles();
  const history = useHistory();

  const dispatch = useDispatch();
  const isMobile = useTheme().breakpoints.down("md");
  const handleNavigate = (link) => {
    window.open(link);
  };
  const openHome = () => {
    history.push("/");
  };

  const panchUrl = "/images/logo/panch.png";

  const gramId = useSelector((state) => state.util.currentGramId);
  const logo = "/images/logo/logo.png";

  return (
    <div className={classes.root}>
      <Toolbar className={classes.toolbarcontainer}>
        <div className={classes.container}>
          <div className={classes.mainContainer}>
            <img
              src={gramId ? getImageUrl(data?.logoUrl) : logo}
              className={classes.logo}
              onClick={() => openHome("/")}
            />

            <div className={classes.gramTitleContainer}>
              <div className={classes.gramTitle}>
                <Typography
                  variant="h6"
                  align="flex-start"
                  className={classes.headline}
                >
                  {data?.gramName}
                </Typography>
              </div>
              <div className={classes.distsubDistrictContainer}>
                <Typography
                  variant="body1"
                  align="flex-start"
                  className={classes.subdistrict}
                >
                  {data?.subDistrictTitle} : {data?.subDistrict}
                </Typography>
                <Typography
                  variant="body1"
                  align="flex-start"
                  className={classes.district}

                  // className={classes.headline}
                >
                  {data?.districtTitle} : {data?.district}
                </Typography>
              </div>
            </div>
          </div>
          <MobileHidden>
            <div className={classes.panchContainer}>
              <img src={panchUrl} className={classes.panch} />
            </div>
          </MobileHidden>

          <div className={classes.otherLogoMainContainer}>
            <DesktopHidden>
              <IconButton
                onClick={() => {
                  dispatch(toggleDrawer());
                }}
              >
                <MenuIcon className={classes.menuIcon} />
              </IconButton>
            </DesktopHidden>
            <MobileHidden>
              <div
                className={classes.otherlogoContainer}
                alignItems="center"
                justify="space-between"
              >
                {data?.otherLogos?.map((logo, index) => {
                  return (
                    <div
                      className={classes.otherlogoItem}
                      item
                      key={index}
                      // onClick={() => handleNavigate(logo.link)}
                    >
                      <img src={logo.src} className={classes.otherLogo} />
                    </div>
                  );
                })}
              </div>
            </MobileHidden>
          </div>
        </div>
      </Toolbar>
    </div>
  );
};
export default Navbar;

//working but layout issues

// import React from "react";
// import { makeStyles } from "@material-ui/core/styles";
// import {
//   Container,
//   Divider,
//   Grid,
//   Hidden,
//   IconButton,
//   Menu,
//   Toolbar,
//   Typography,
//   useTheme,
// } from "@material-ui/core";
// import { useDispatch } from "react-redux";
// import fontConfig from "../../constants/fonts";
// import MenuIcon from "@material-ui/icons/Menu";
// import { toggleDrawer } from "../../redux/action/utilActions";
// import { useHistory } from "react-router-dom";
// import MobileHidden from "../../components/Common/Hidden/MobileHidden";
// import DesktopHidden from "../../components/Common/Hidden/DesktopHidden";

// const logo = "/assets/images/logo/logo-light2.jpeg";

// const breakpoint = (theme, style) => {
//   return {
//     [theme.breakpoints.down("md")]: {
//       ...style,
//     },
//   };
// };
// const useStyles = makeStyles((theme) => ({
//   root: {
// backgroundColor: "white",
// ...breakpoint(theme, {
//   marginTop: "1vh",
//   marginBottom: "1vh",
// }),
//   },
// logo: {
//   height: 80,
//   marginBottom: theme.spacing(1),
//   marginTop: theme.spacing(1),
//   paddingTop: theme.spacing(1),

//   cursor: "pointer",
//   [theme.breakpoints.down("md")]: {
//     paddingTop: theme.spacing(0),
//     marginTop: theme.spacing(0),
//     height: 60,
//     marginBottom: theme.spacing(0),
//   },
//   // width: "20vh",
// },
//   logoContainer: {},

// headline: {
//   ...fontConfig.medium,
//   fontSize: "1.2rem",
// },
// otherLogo: {
//   height: 50,
// },
// menuIcon: {
//   fontSize: "2rem",
// },
//   districtItem: {
//     paddingLeft: theme.spacing(1),
//     [theme.breakpoints.down("md")]: {
//       paddingLeft: theme.spacing(1),
//       fontSize: "0.7rem",
//     },
//   },
//   headline: {
//     paddingLeft: theme.spacing(1),
//     [theme.breakpoints.down("md")]: {
//       paddingLeft: theme.spacing(1),
//       fontSize: "1rem",
//     },
//   },
// subdistrict: {
//   [theme.breakpoints.down("md")]: {
//     fontSize: "0.7rem",
//   },
// },
// district: {
//   [theme.breakpoints.down("md")]: {
//     fontSize: "0.7rem",
//   },
// },
// }));

// const NavBar = ({ data }) => {
//   const classes = useStyles();
// const history = useHistory();
//   const dispatch = useDispatch();
// const isMobile = useTheme().breakpoints.down("md");

// const handleNavigate = (link) => {
//   window.open(link);
// };
// const openHome = () => {
//   history.push("/");
// };
//   return (
//     <div className={classes.root}>
//       <Toolbar className={classes.container} maxWidth="lg">
//         <Grid container spacing={1} alignItems="center">
//           <Grid
//             item
//             lg={1}
//             md={1}
//             sm={2}
//             xs={2}
//             className={classes.logoContainer}
//             container
//             alignItems="center"
//             // justify="flex-end"
//           >
//             <Grid item onClick={() => openHome("/")}>
// <img src={data?.logoUrl} className={classes.logo} />
//             </Grid>
//             {/* <Grid item lg={7}>
//               <Typography variant="h4" className={classes.logoTitle}>
//                 {data?.title || "E-Gram Panchayat"}
//               </Typography>
//             </Grid> */}
//           </Grid>
//           <Grid
//             item
//             lg={7}
//             md={7}
//             sm={7}
//             xs={7}
//             container
//             alignItems="center"
//             className={classes.titleContainer}
//             justify="flex-start"
//           >
//             <Grid item lg={12}>
// <Typography
//   variant="h6"
//   align="flex-start"
//   className={classes.headline}
// >
//   {data?.gramName}
// </Typography>
//             </Grid>
//             <Grid
//               item
//               lg={"auto"}
//               sm={5}
//               xs={5}
//               md={12}
//               className={classes.districtItem}
//             >
// <Typography
//   variant="body1"
//   align="flex-start"
//   className={classes.subdistrict}
// >
//   {data?.subDistrictTitle} : {data?.subDistrict}
// </Typography>
//             </Grid>
//             <Grid
//               item
//               lg={"auto"}
//               sm={6}
//               xs={6}
//               md={12}
//               className={classes.districtItem}
//             >
// <Typography
//   variant="body1"
//   align="flex-start"
//   className={classes.district}

//   // className={classes.headline}
// >
//   {data?.districtTitle} : {data?.district}
// </Typography>
//             </Grid>
//           </Grid>

// <DesktopHidden>
//   <Grid item lg={3} sm={3} md={3} xs={3} container justify="flex-end">
//     <IconButton
//       onClick={() => {
//         dispatch(toggleDrawer());
//       }}
//     >
//       <MenuIcon className={classes.menuIcon} />
//     </IconButton>
//   </Grid>
// </DesktopHidden>
// <MobileHidden>
//   <Grid
//     item
//     lg={4}
//     container
//     className={classes.otherLogosContainer}
//     alignItems="center"
//     justify="space-between"
//   >
//     {data?.otherLogos?.map((logo, index) => {
//       return (
//         <Grid
//           item
//           key={index}
//           onClick={() => handleNavigate(logo.link)}
//         >
//           <img src={logo.src} className={classes.otherLogo} />
//         </Grid>
//       );
//     })}
//   </Grid>
// </MobileHidden>
//         </Grid>
//       </Toolbar>
//       <Divider />
//     </div>
//   );
// };
// export default NavBar;

// // import React from "react";
// // import { makeStyles } from "@material-ui/core/styles";
// // import {
// //   Container,
// //   Divider,
// //   Grid,
// //   Toolbar,
// //   Typography,
// // } from "@material-ui/core";
// // import fontConfig from "../../constants/fonts";

// // const logo = "/assets/images/logo/logo-light2.jpeg";
// // const useStyles = makeStyles((theme) => ({
// //   root: {
// //     backgroundColor: "white",
// //   },
// //   logo: {
// //     height: "15vh",
// //     // width: "20vh",
// //   },
// //   logoContainer: {},
// //   logoTitle: {
// //     ...fontConfig.medium,
// //     fontSize: 25,
// //     color: theme.palette.primary.dark,
// //   },
// //   headline: {
// //     paddingLeft: theme.spacing(1),

// //     ...fontConfig.medium,
// //     fontSize: "1.5rem",
// //   },
// //   otherLogo: {
// //     height: "8vh",
// //   },
// // districtItem: {
// //   paddingLeft: theme.spacing(1),
// // },
// // titleContainer: {
// //   // backgroundColor: theme.palette.primary.main,
// // },
// // }));

// // const NavBar = ({ data }) => {
// //   const classes = useStyles();

// //   return (
// //     <div className={classes.root}>
// //       <Toolbar className={classes.container} maxWidth="lg">
// //         <Grid container alignItems="center">
// //           <Grid
// //             item
// //             lg={1}
// //             className={classes.logoContainer}
// //             container
// //             alignItems="center"
// //             justify="center"
// //           >
// //             <Grid item lg={12}>
// //               <img src={data?.logoUrl} className={classes.logo} />
// //             </Grid>
// //             {/* <Grid item lg={7}>
// //               <Typography variant="h4" className={classes.logoTitle}>
// //                 {data?.title || "E-Gram Panchayat"}
// //               </Typography>
// //             </Grid> */}
// //           </Grid>
// //           <Grid
// //             item
// //             lg={6}
// //             container
// //             alignItems="center"
// //             className={classes.titleContainer}
// //             justify="flex-start"
// //           >
// //             <Grid item lg={12}>
// //               <Typography
// //                 variant="h6"
// //                 align="flex-start"
// //                 className={classes.headline}
// //               >
// //                 {data?.gramName}
// //               </Typography>
// //             </Grid>
// //             <Grid item className={classes.districtItem}>
// //               <Typography
// //                 variant="body1"
// //                 align="flex-start"
// //                 // className={classes.headline}
// //               >
// //                 {data?.subDistrictTitle} : {data?.subDistrict}
// //               </Typography>
// //             </Grid>
// //             <Grid item className={classes.districtItem}>
// //               <Typography
// //                 variant="body1"
// //                 align="flex-start"
// //                 // className={classes.headline}
// //               >
// //                 {data?.districtTitle} : {data?.district}
// //               </Typography>
// //             </Grid>
// //           </Grid>
// //           <Grid
// //             item
// //             lg={4}
// //             container
// //             className={classes.otherLogosContainer}
// //             alignItems="center"
// //             justify="space-between"
// //           >
// //             {data?.otherLogos?.map((logo, index) => {
// //               return (
// //                 <Grid item key={index}>
// //                   <img src={logo.src} className={classes.otherLogo} />
// //                 </Grid>
// //               );
// //             })}
// //           </Grid>
// //         </Grid>
// //       </Toolbar>
// //       <Divider />
// //     </div>
// //   );
// // };
// // export default NavBar;
